function normalizeRegistryKey(value = '') {
  return String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .toLowerCase()
    .replace(/[^\p{L}\p{N}]+/gu, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')
}

function toTextArray(value) {
  if (Array.isArray(value)) return value.map((entry) => String(entry || '').trim()).filter(Boolean)
  if (value === null || value === undefined) return []
  const text = String(value || '').trim()
  return text ? [text] : []
}

const REGISTRY = Object.freeze({
  monster: Object.freeze({
    efreeti: Object.freeze(['Ifrit', 'Ifreet', 'Afreet', 'Afrit', 'Efreet', 'Efriti'])
  }),
  spell: Object.freeze({}),
  class: Object.freeze({}),
  note: Object.freeze({}),
  vault: Object.freeze({}),
  character: Object.freeze({})
})

export function getEntityAliases(entityType = '', ...keys) {
  const typeKey = normalizeRegistryKey(entityType)
  const bucket = REGISTRY[typeKey] || {}
  const aliases = new Set()

  for (const rawKey of keys.flatMap((value) => toTextArray(value))) {
    const normalizedKey = normalizeRegistryKey(rawKey)
    if (!normalizedKey) continue
    const entries = bucket[normalizedKey]
    if (!Array.isArray(entries)) continue
    for (const entry of entries) {
      const text = String(entry || '').trim()
      if (text) aliases.add(text)
    }
  }

  return Array.from(aliases)
}

export function getAliasesAcrossEntityTypes(...keys) {
  const aliases = new Set()
  for (const entityType of Object.keys(REGISTRY)) {
    for (const alias of getEntityAliases(entityType, ...keys)) {
      aliases.add(alias)
    }
  }
  return Array.from(aliases)
}

export { normalizeRegistryKey }
